
import { InputControllerType1 } from "../controller/InputControllerType1";
import React, { Dispatch } from "react";
import { TFunction } from "i18next";
import CSSClassSerivce from "../../../../services/CommonCSSSerivce";
import { IRadiosControllerType1, IRadiosControllerType1Return } from "./RadiosControllerType1";
import { IInputValidationItemProps, IInputValidatorItem } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";
import { IInputValidationControllerReturn } from "../../../../factorys/inputvalidation/InputValidationController";
import InputValidationFactory from "../../../../factorys/inputvalidation/InputValidationFactory";
import { InputValidation } from "../../../../factorys/inputvalidation/InputValidation";
import { EInputValidationResultType } from "../../../../factorys/inputvalidation/enums/InputValidationEnums";
import { IEditBaseControllerReturn } from "../../../../../../app/main/gui/controllers/EditBaseController";
import { ELng } from "../../../../../../language/main/LanguageKeysEnums";
import { IGUIElementController } from "../../../../factorys/guielements/CommonReactGUIElementsInterfaces";


//#region wrapper
interface IProps extends IInputValidationItemProps {
  label: string;
  groupName: string;
  required?: boolean;
  options?: string[];
  currentOption: string | undefined;   
  onInputChange?: ((it: string) => void) | null,
  t: TFunction<"translation", undefined>,
  c: IGUIElementController;
  descPrefix: string;
  //css
  classNameRootFrame?: string;
  classNameBaseFrame?: string;
  classNameFrame?: string;
  classNameInput?: string;
  classNameDisabled: string;
  //functions
  classNameAddByOption?: (option: string) => string;
  //validations
  validationItems?: IInputValidatorItem[] | null | undefined;
  onInputValidation?: ((it: EInputValidationResultType) => void) | null | undefined;
}

const RadiosType1: React.FC<IProps> = (props) => {

  //init controllers
  const bc = IRadiosControllerType1<string>({
    value: props.currentOption,
    disabled: props.c.isDisabled,
    classNameFrame: props.classNameBaseFrame,
    disabledClass: props.classNameDisabled,
  })

  const ivc = InputValidationFactory.getInputValidationController({
    validationItems: props.validationItems, 
    itemProps: props,
    itemController: bc,
    onMount:()=>{ ivc?.validate({value: bc.value, ignoreBlur: false })}
  });

  //#region functions
  // const inputValidation = (ivc: IInputValidationControllerReturn | null, value: string) => {
  //   if (ivc == null) return;

  //   //validate with no message
  //   //if (!bc.blur) { props.fInputIsValid ? props.fInputIsValid(ivc.strIsValidNoMessage(value)) : {}; return; }

  //   //include message
  //   props.inputIsValid ? props.inputIsValid(ivc.strIsValid(value)) : {};
  //   //props.inputIsValid ? props.inputIsValid(false) : {};
  // }
  //#endregion


  return (
    <div className={CSSClassSerivce.radioClassRootFrame}>
      <label className="text-sm font-medium flex flex-row"> 
        {props.t(props.label)}
        <p className="pl-1">{props.required?" *":""}</p>
        </label>
      <div ref={(it) => { bc.setRefFrame(it)}}  >
        
        {props.options?.map((option) => {
          return <RadioType1
            //parentProps
            currentOption={bc.value}
            setCurrentOption={bc.setValue}
            //selfProps
            value={option}
            desc={props.descPrefix+option}
            isDisabled={props.c.isDisabled}
            onInputChange={(it) => { 
              try {
                ivc?.validate({value: it, ignoreBlur: true});
                //(ivc != null) ? inputValidation(ivc, it) : null;
                props.onInputChange!!(it) 
              } catch (e) {
              } 
            }}
            groupName={props.groupName} 
            //classNameFrame={CSSClassSerivce.radioClassFrame + " " + props.classNameAddByOption?(props.classNameAddByOption?(option):""):""}
            classNameFrame={`${CSSClassSerivce.radioClassFrame} ${props.classNameAddByOption?props.classNameAddByOption(option):""}`}
            classNameInput={`${CSSClassSerivce.radioClassInput}`}
            classNameDisabled={props.classNameDisabled}
            t={props.t}
            ivc={ivc}
            cParent={bc}
          />
        })}
      </div>
      <div className={"ml-7"}>
        {(ivc != null) ? <InputValidation ivc={ivc} /> : <></>}
      </div>
    </div>
  );
};
//#endregion


//#region radioItem
interface IRadioProps {
  cParent: IRadiosControllerType1Return<string>;
  currentOption: string | undefined;
  setCurrentOption: Dispatch<string>;
  value: string;
  groupName: string;
  desc: string;
  onInputChange?: ((it: string) => void) | null;
  classNameFrame: string;
  classNameInput: string;
  classNameDisabled: string;
  isDisabled?: boolean | undefined;
  t: TFunction<"translation", undefined>;
  ivc: IInputValidationControllerReturn | null;
}

const RadioType1: React.FC<IRadioProps> = (props) => {

  const c = InputControllerType1({
    value: props.currentOption,
    disabled: props.isDisabled,
    classNameFrame: props.classNameFrame,
    classNameInput: props.classNameInput,
    disabledClass: props.classNameDisabled
  })

  return (
      <div
        ref={(it) => { c.setRefFrame(it) }}
        className={props.classNameFrame}
        onClick={(e) => {
          try {
            if (props.isDisabled == true) return;
            props.setCurrentOption(props.value);
            props.onInputChange!!(props.value);
          } catch (e) { }
        }}
      >
        <input
          //key={props.value}
          ref={(it) => { c.setRefInput(it) }}
          type="radio"
          className={props.classNameInput}
          name={props.groupName}
          //checked={true}
          checked={(props.value == props.currentOption)?true:false}
          defaultChecked={(props.value == props.currentOption)?true:false}
          onChange={(e) => {}} //hint: onChange preventes react warning messages
          onBlur={(e) => {
            props.ivc?.strValidationIsVisible(e.target.value)
            props.cParent.setBlur(true)
          }}
        />
        <label className="text-sm font-medium ml-2 pointer-events-none">
          {props.t(props.desc ? props.desc : ELng._null.valueOf())}
          </label>
      </div>
  )
}
//#endregion

export default RadiosType1;